export default __webpack_public_path__ + "scripts/resources/assignments/en/default/spectra.json";